import React from 'react';
import { Input, Select } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { objectEntries } from 'src/utils/objectEntries';
import MultiSelectionList from 'src/components/common/MultiSelectionList';
import { FileFormat, fileFormat } from 'src/components/common/ExportButton';
import { columnOptions } from '../AlertResultExport.config';
import styles from './ExportConfigurationTable.module.less';

type TableProps = {
  name: string;
  format: FileFormat;
  placeholder: string;
  selectedColumns: string[];
  onNameChange: (name: string) => void;
  onFormatChange: (format: FileFormat) => void;
  onColumnsChange: (columnIds: CheckboxValueType[]) => void;
};

export const ExportConfigurationTable: React.FC<TableProps> = ({
  name,
  format,
  placeholder,
  selectedColumns,
  onNameChange,
  onFormatChange,
  onColumnsChange,
}) => (
  <table className={styles.table}>
    <tbody>
      <tr>
        <td>Name:</td>
        <td>
          <Input type="text" value={name} placeholder={placeholder} onChange={(e) => onNameChange(e.target.value)} />
        </td>
      </tr>
      <tr>
        <td>Format:</td>
        <td>
          <Select value={format} onChange={onFormatChange}>
            {objectEntries(fileFormat).map(([key, label]) => (
              <Select.Option key={key} value={key}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </td>
      </tr>
      <tr>
        <td>Columns:</td>
        <td>
          <MultiSelectionList
            className={styles.columnsList}
            search={false}
            value={selectedColumns}
            data={columnOptions}
            selectAllEnabled={true}
            selectAllLabel={'All columns'}
            onChange={onColumnsChange}
          />
        </td>
      </tr>
    </tbody>
  </table>
);
